var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCircle = function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 .68c4.61 0 8.32 3.71 8.32 8.32S13.61 17.32 9 17.32.68 13.61.68 9 4.39.68 9 .68M6.93 11.227c0 .664.703 1.054 1.289.703l3.437-2.227c.508-.312.508-1.094 0-1.406L8.22 6.07c-.586-.351-1.29.04-1.29.703z"
  })));
};
export default SvgPlayCircle;